import { API_URI } from '../../constants/env';
import instance from './axios';

const ENDPOINTS = {
  OPTIONS: '/options',
};

const getOptions = () => {
  return instance.get<any>(ENDPOINTS.OPTIONS, {
    baseURL: API_URI + '/wp-json/kcc/v1',
  });
};

const OptionsApi = {
  getOptions,
};

export default OptionsApi;
